import apiClient from './axiosClient';

export const eftEnrollmentApi = {

    
    create: async (params) => {
        console.log("ENROLLMENT CREATE PARAMS:", JSON.stringify(params));
        

        //return;

        const request = {
            reason: params.reason ?? "",

            legalName: params.legalName ?? "",
            dba: params.dba || null,
            tin: params.tin ?? "",
            npi: params.npi ?? "",

            contactName: params.contact ?? "",
            email: params.email ?? "",

            tradingPartnerId: params.tradingPartnerId || null,
            telephone: params.phone ?? "",
            fax: params.fax || null,

            streetAddress: params.address ?? "",
            city: params.city ?? "",
            state: params.state ?? "",
            zip: params.zip ?? "",

            thirdPartyAgent: !!(
                params.agentName ||
                params.agentPhone ||
                params.agentEmail
            ),

            agentName: params.agentName || null,
            agentPhone: params.agentPhone || null,
            agentEmail: params.agentEmail || null,

            bankName: params.bankName ?? "",
            routingNumber: params.routing ?? "",
            accountType: params.accountType ?? "",
            accountNumber: params.account ?? "",

            
            //linkAccountTo: params.linkTo?.split('—')[1]?.trim() ?? "", 
            linkAccountTo: params?.linkTo?.slice(4).trim() ?? "", //remove "TIN-|NPI-"
            bankContactPhone: params.bankPhone || null,

            //effectiveDate: params.effectiveDate
            //    ? `${params.effectiveDate}T00:00:00`
            //    : null,

            effectiveDate: params.effectiveDate
                ? `${params.effectiveDate}`
                : null,

            authorizedSigner: params.signer ?? "",
            title: params.title ?? "",
            electronicSignature: params.signature ?? "",

            //signatureDate: params.signatureDate
            //    ? `${params.signatureDate}T00:00:00`
            //    : null,

            signatureDate: params.signatureDate
                ? `${params.signatureDate}`
                : null,

            attestation: params.attestation,

            userId: params.userId || null
        };

        console.log("EFT ENROLLMENT API REQUEST:", JSON.stringify(request));

        const res = await apiClient.post(
            '/api/provider/SubmitEFTEnrollment',
            request
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },

    getByTaxId: async (params) => {
        const res = await apiClient.post(
            `/api/provider/getEFTEnrollmentByTaxId`, {
                taxId: params.taxId,
                userId : params.userId
            }
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };

        return res.data;
    },

    //getEFTEnrollmentList: async () => {
    //    const res = await apiClient.get(
    //        '/api/provider/getEFTEnrollmentList'
    //    );

    //    const data = res?.data;

    //    return {
    //        success: data?.Success,
    //        message: data?.Message,
    //        data: data?.Data || []   //  all properties preserved
    //    };
    //},
    getEFTEnrollmentList: async ({
        searchText = '',
        status = "All",
        sortColumnName = '',
        sortColumnDirection = '',
        startIndex = 0,
        pageSize = 10,
        exportCsv = false
    } = {}) => {

        const res = await apiClient.get(
            '/api/provider/getEFTEnrollmentList2',
            {
                params: {
                    searchText,
                    status,
                    sortColumnName,
                    sortColumnDirection,
                    startIndex,
                    pageSize,
                    exportCsv
                }
            }
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || [],

            // Pagination information
            totalRecord: data?.TotalRecord || 0,
            statusCounts: data?.StatusCounts || [],
            startIndex: data?.StartIndex || 0,
            pageSize: data?.PageSize || pageSize
        };
    },

    update: async (params) => {

        //console.log("UPDATE PARAMS : " + JSON.stringify(params));
        //return;
        
        const request = {
            eFTEnrollmentId: params.eFTEnrollmentId,
            reason: params.reason ?? "",

            legalName: params.legalName ?? "",
            dba: params.dba || null,
            tin: params.tin ?? "",
            npi: params.npi ?? "",

            contactName: params.contact ?? "",
            email: params.email ?? "",

            tradingPartnerId: params.tradingPartnerId || null,
            telephone: params.phone ?? "",
            fax: params.fax || null,

            streetAddress: params.address ?? "",
            city: params.city ?? "",
            state: params.state ?? "",
            zip: params.zip ?? "",

            thirdPartyAgent: !!(
                params.agentName ||
                params.agentPhone ||
                params.agentEmail
            ),

            agentName: params.agentName || null,
            agentPhone: params.agentPhone || null,
            agentEmail: params.agentEmail || null,

            bankName: params.bankName ?? "",
            routingNumber: params.routing ?? "",
            accountType: params.accountType ?? "",
            accountNumber: params.account ?? "",

            //linkAccountTo: params.linkTo ?? "",
            linkAccountTo: params?.linkTo?.slice(4).trim() ?? "", //remove "TIN-|NPI-"
            bankContactPhone: params.bankPhone || null,

            effectiveDate: params.effectiveDate
              //  ? `${params.effectiveDate}T00:00:00`
                ? `${params.effectiveDate}`
                : null,

            authorizedSigner: params.signer ?? "",
            title: params.title ?? "",
            electronicSignature: params.signature ?? "",

            signatureDate: params.signatureDate
             //   ? `${params.signatureDate}T00:00:00`
                ? `${params.signatureDate}`
                : null,

            attestation: params.attestation,

            userId: params.userId || null
        };
        

        const res = await apiClient.post(
            '/api/provider/updateEFTEnrollment',
            request
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },

    getNpiFromTaxId: async (params) => {
        const res = await apiClient.get(
            `/api/provider/getNpiFromTaxId?TaxId=${params?.taxId?.trim()}`
            
        );      


        const data = res?.data;        

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },

    getStatusHistory: async (eftEnrollmentId) => {
        const response = await apiClient.get(
            `/api/provider/admin/getEFTEnrollmentStatusHistory/${eftEnrollmentId}`
        );

        return response.data;
    },
     
    updateEftEnrollmentStatus: async (params) =>
    {
            console.log("ENROLLMENT UPDATE STATUS PARAMS:", JSON.stringify(params));

            const request = {
                eFTEnrollmentId: params.id,
                status: params.newStatus,
                notes: params.statusNotes,
            };

            //console.log("EFT ENROLLMENT API REQUEST:", JSON.stringify(request));

            const res = await apiClient.post(
                '/api/provider/admin/updateEFTEnrollmentStatus',
                request
            );

            const data = res?.data;

            return {
                success: data?.Success,
                message: data?.Message,
                data: data?.Data || []   //  all properties preserved
            };
    },
    getProviderAdmins: async (params = {}) => {
        console.log(
            "GET PROVIDER ADMINS PARAMS:",
            JSON.stringify(params)
        );

        const queryParams = new URLSearchParams();

        if (params.search?.trim()) {
            queryParams.append(
                'search',
                params.search.trim()
            );
        }

        queryParams.append(
            'first',
            String(params.first ?? 0)
        );

        queryParams.append(
            'max',
            String(params.max ?? 20)
        );

        const res = await apiClient.get(
            `/api/provider/admin/users/provider-admins?${queryParams.toString()}`
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []
        };
    },


};
